export default __webpack_public_path__ + "static/media/arrow-up-black.43ea21ad.svg";